import React from 'react';

/**
 * 地图右侧参数面板（缩放/高度/海拔 + 救援摘要）
 * @param {'desktop'|'mobile'} variant
 */
export default function DashboardMapStatusPanel({
  variant = 'desktop',
  visible,
  animVisible = true,
  mapStatus,
  rescueTargets = [],
  rescueTracks = [],
  onToggle
}) {
  const compact = variant === 'mobile';
  if (visible) {
    return (
      <div
        className={`left-panel ${animVisible ? 'visible' : 'hidden'}`}
        style={{
          position: 'absolute',
          right: 18,
          top: compact ? 100 : 140,
          zIndex: 25,
          background: 'rgba(255,255,255,0.95)',
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          padding: '6px 12px',
          fontSize: 12,
          color: '#222',
          minWidth: 0,
          width: 'auto',
          lineHeight: 1.5,
          display: 'inline-block',
          maxWidth: 220,
          wordBreak: 'break-all',
          cursor: 'pointer'
        }}
        onClick={onToggle}
        title="点击切换显示/隐藏"
      >
        <div><b>缩放级别：</b>{Number(mapStatus?.zoom || 0).toFixed(2)}</div>
        <div>
          <b>离地高度：</b>
          {mapStatus?.heightStatus === 'paused'
            ? '地球模式暂停'
            : mapStatus?.height != null
              ? `${mapStatus.height} 米`
              : mapStatus?.heightStatus === 'loading'
                ? '计算中...'
                : '—'}
        </div>
        <div>
          <b>指针海拔：</b>
          {mapStatus?.pointerElevationStatus === 'paused'
            ? '地球模式暂停'
            : mapStatus?.pointerElevation != null
              ? `${Math.round(mapStatus.pointerElevation)} 米`
              : mapStatus?.pointerElevationStatus === 'loading'
                ? '查询中...'
                : mapStatus?.pointerElevationStatus === 'unavailable'
                  ? '暂无数据'
                  : '—'}
        </div>
        <div>
          <b>中心海拔：</b>
          {mapStatus?.elevationStatus === 'paused'
            ? '地球模式暂停'
            : mapStatus?.elevation != null
              ? `${Math.round(mapStatus.elevation)} 米`
              : mapStatus?.elevationStatus === 'loading'
                ? '查询中...'
                : mapStatus?.elevationStatus === 'unavailable'
                  ? '暂无数据'
                  : '—'}
        </div>
        {(rescueTargets.length > 0 || rescueTracks.length > 0) && (
          <div style={{ marginTop: '4px', borderTop: '1px solid #ddd', paddingTop: '4px' }}>
            <div style={{ color: '#d32f2f', fontWeight: 'bold', fontSize: compact ? '11px' : undefined }}>
              🚨 救援数据
            </div>
            {rescueTargets.length > 0 && (
              <div style={compact ? { fontSize: '11px' } : undefined}>
                <b>救援目标：</b>{rescueTargets.length}{compact ? '个' : ''}
              </div>
            )}
            {rescueTracks.length > 0 && (
              <div style={compact ? { fontSize: '11px' } : undefined}>
                <b>救援轨迹：</b>{rescueTracks.length}{compact ? '条' : ''}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      style={{
        position: 'absolute',
        right: 18,
        top: compact ? 100 : 140,
        zIndex: 25,
        background: 'rgba(255,255,255,0.9)',
        borderRadius: '50%',
        width: compact ? 28 : 32,
        height: compact ? 28 : 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        border: '1px solid rgba(255,255,255,0.3)',
        transition: 'all 0.2s ease'
      }}
      onClick={onToggle}
      title="显示地图参数"
      onMouseEnter={
        compact
          ? undefined
          : (e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,1)';
              e.currentTarget.style.transform = 'scale(1.1)';
            }
      }
      onMouseLeave={
        compact
          ? undefined
          : (e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.9)';
              e.currentTarget.style.transform = 'scale(1)';
            }
      }
    >
      <span style={{ fontSize: compact ? 14 : 16, color: '#1976d2' }}>🗺️</span>
    </div>
  );
}
